import { useEffect } from 'react';

export function AuthCallback() {
  useEffect(() => {
    // El backend ya guardó los tokens de Spotify en Firestore.
    // El listener de useSpotifyStatus detecta el cambio automáticamente.
    try { window.close(); } catch {}
  }, []);

  return <p>Spotify conectado. Podés cerrar esta ventana.</p>;
}
